export enum VendorId {
  FireLight = 1,
  RetireUp = 3,
  IPipeline = 4,
  Aspida = 5,
}